import { render, staticRenderFns } from "./TeamsCard.vue?vue&type=template&id=405709aa&scoped=true&"
import script from "./TeamsCard.vue?vue&type=script&lang=js&"
export * from "./TeamsCard.vue?vue&type=script&lang=js&"
import style0 from "./TeamsCard.vue?vue&type=style&index=0&id=405709aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405709aa",
  null
  
)

export default component.exports